import ToggleIcon from "@assets/images/svg/toggleIcon.svg?react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ListIcon from "@mui/icons-material/List";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import { Box, Menu, MenuList } from "@mui/material";
import { useContext, useState } from "react";

import { useStyles } from "../styles";
import { SVMenuContext } from "../sv-menu-context";
import { featureTitle } from "./constants";
import { TextGroupMenu } from "./text-group-menu";

// Helper function to get the corresponding icon
const getIconForFeature = (feature: string) => {
  switch (feature) {
    case featureTitle[0]:
      return <TextFieldsIcon fontSize="small" />;
    case featureTitle[1]:
      return "H1";
    case featureTitle[2]:
      return "H2";
    case featureTitle[3]:
      return "H3";
    case featureTitle[4]:
      return <ListIcon fontSize="small" />;
    case featureTitle[5]:
      return <ToggleIcon width={20} height={20} />;
    default:
      return null;
  }
};

export const TextGroup = (): JSX.Element => {
  const { editor, subMenuOpen, setSubMenuOpen, isOtherSubMenuOpen } =
    useContext(SVMenuContext);
  const classes = useStyles();
  const [textAnchorEl, setTextAnchorEl] = useState<null | HTMLElement>(null);
  const [feature, setFeature] = useState<string>(featureTitle[0]);

  const handleClose = () => {
    if (setSubMenuOpen) {
      setSubMenuOpen({
        ...subMenuOpen,
        textGroup: false,
      });
    }

    setTextAnchorEl(null);
  };

  return (
    <>
      <button
        type="button"
        onClick={(event) => {
          if (!textAnchorEl) {
            setSubMenuOpen({
              ...subMenuOpen,
              textGroup: true,
            });
            setTextAnchorEl(event.currentTarget);
          } else {
            setSubMenuOpen({
              ...subMenuOpen,
              textGroup: false,
            });
            setTextAnchorEl(null);
          }
        }}
        className={classes.default}
        style={{
          minWidth: 100,
          flexShrink: 0,
          border: "2px solid white",
        }}
        disabled={isOtherSubMenuOpen("textGroup")}
      >
        <Box display="flex" alignItems="center">
          {/* Display the icon and feature name */}
          <span style={{ verticalAlign: "super" }}>
            {getIconForFeature(feature)}
          </span>
          <span style={{ marginLeft: 8 }}>{feature}</span>
          {/* Arrow-down icon */}
          <span style={{ verticalAlign: "bottom", marginLeft: 8 }}>
            <KeyboardArrowDownIcon fontSize="small" />
          </span>
        </Box>
      </button>

      <Menu
        anchorEl={textAnchorEl}
        open={Boolean(textAnchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <MenuList>
          <TextGroupMenu
            editor={editor}
            handleClose={handleClose}
            setFeature={setFeature}
          />
        </MenuList>
      </Menu>
    </>
  );
};
